
.screen {
  display: grid;
  gap: var(--space-3);
  width: 100%;
  min-width: 0;
  color: var(--color-text-body);
}

.header {
  display: grid;
  gap: var(--space-1);
}

.kicker {
  margin: 0;
  color: var(--color-text-tertiary);
  font-size: 0.75rem;
  font-weight: 750;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.title {
  margin: 0;
  color: var(--color-text-primary);
  font-size: clamp(1.8rem, 3vw, 2.5rem);
  line-height: 1.08;
  letter-spacing: -0.045em;
}

.searchPanel,
.mapPanel,
.semanticPanel,
.inspector {
  border: 1px solid var(--color-hairline);
  border-radius: var(--radius-surface);
  background: var(--color-surface);
}

.searchPanel {
  display: grid;
  gap: var(--space-2);
  width: min(100%, 56rem);
  padding: var(--space-2);
}
.onboarding {
  display: grid;
  gap: var(--space-2);
  width: min(100%, 56rem);
  padding: var(--space-3);
  border: 1px solid var(--color-hairline);
  border-radius: var(--radius-surface);
  background: var(--color-surface);
}

.onboarding h2 {
  margin: 0;
  color: var(--color-text-primary);
}

.onboardingSteps {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: var(--space-1);
}

.onboardingSteps article {
  display: grid;
  gap: 4px;
  padding: var(--space-2);
  border: 1px solid var(--color-hairline);
  border-radius: var(--radius-control);
  background: var(--color-recessed);
}

.onboardingSteps span {
  color: var(--color-text-secondary);
  font-size: 0.875rem;
}

.onboardingLinks {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-1);
}

.exampleNotice {
  margin: 0;
  padding: var(--space-1) var(--space-2);
  border: 1px solid var(--color-accent);
  border-radius: var(--radius-control);
  background: var(--color-accent-subtle);
  color: var(--color-accent);
  font-weight: 700;
}


.searchForm {
  display: grid;
  gap: var(--space-1);
}

.searchForm label {
  color: var(--color-text-primary);
  font-weight: 700;
}

.searchLine {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: var(--space-1);
}

.searchLine input,
.linkForm select,
.linkForm input {
  min-width: 0;
  min-height: var(--target-min);
  padding-inline: var(--space-2);
  border: 1px solid var(--color-boundary);
  border-radius: var(--radius-control);
  background: var(--color-canvas);
  color: var(--color-text-primary);
  font: inherit;
}

.searchLine input::placeholder,
.linkForm input::placeholder {
  color: var(--color-text-tertiary);
}
.searchButton,
.compactButton,
.dangerButton {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-1);
  min-height: var(--target-min);
  padding-inline: var(--space-2);
  border: 1px solid var(--color-boundary);
  border-radius: var(--radius-control);
  background: var(--color-surface);
  color: var(--color-text-primary);
  font: inherit;
  font-weight: 650;
  cursor: pointer;
}

.searchButton {
  border-color: var(--color-accent);
  background: var(--color-accent);
  color: var(--color-action-inverse-text);
}

.compactButton[aria-pressed="true"] {
  border-color: var(--color-accent);
  background: var(--color-accent-subtle);
  color: var(--color-accent);
}

.searchButton:disabled,
.compactButton:disabled,
.dangerButton:disabled {
  cursor: not-allowed;
  opacity: 0.55;
}

.searchButton:focus-visible,
.compactButton:focus-visible,
.dangerButton:focus-visible,
.searchLine input:focus-visible,
.linkForm select:focus-visible,
.linkForm input:focus-visible,
.rootResult:focus-visible,
.itemRow:focus-visible,
.itemSelect:focus-visible,
.itemAction:focus-visible,
.node:focus-visible,
.edge:focus-visible {
  outline: var(--focus-outline-width) solid var(--focus-outline-color);
  outline-offset: var(--focus-outline-offset);
  box-shadow: var(--focus-keyline);
}

.results {
  display: grid;
  gap: var(--space-2);
  padding-top: var(--space-2);
  border-top: 1px solid var(--color-hairline);
}

.resultHeader,
.viewActions,
.pagination,
.inspectorHeader {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: var(--space-1);
}

.resultHeader {
  justify-content: space-between;
}

.resultHeader h2,
.mapHeader h2,
.semanticHeader h2,
.inspector h2 {
  margin: 0;
  color: var(--color-text-primary);
  font-size: 1rem;
}

.rootResults {
  display: grid;
  gap: 2px;
  max-height: 18rem;
  margin: 0;
  padding: 0;
  overflow-y: auto;
  list-style: none;
}

.rootResult {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto auto;
  align-items: center;
  width: 100%;
  gap: var(--space-1);
  min-height: var(--target-min);
  padding: var(--space-1);
  border: 1px solid transparent;
  border-radius: var(--radius-control);
  background: transparent;
  color: var(--color-text-primary);
  text-align: start;
  cursor: pointer;
}

.rootResult:hover {
  border-color: var(--color-hairline);
  background: var(--color-surface-raised);
}

.rootResultLabel,
.rootResultType,
.itemLabel,
.itemType {
  min-width: 0;
}

.rootResultLabel,
.itemLabel {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 700;
}

.rootResultType,
.itemType,
.resultMeta,
.status,
.error,
.inspectorMeta {
  color: var(--color-text-secondary);
  font-size: 0.875rem;
}

.rootResultType,
.itemType {
  white-space: nowrap;
}

.resultArrow {
  color: var(--color-accent);
  font-size: 1.125rem;
  font-weight: 700;
}
.resultAction {
  color: var(--color-accent);
  font-size: 0.8125rem;
  font-weight: 750;
  white-space: nowrap;
}

.status,
.error,
.inspectorMeta {
  margin: 0;
}

.error {
  color: var(--color-danger);
  font-weight: 650;
}

.content {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(17rem, 22rem);
  align-items: start;
  gap: var(--space-2);
  min-width: 0;
}

.mapPanel,
.semanticPanel,
.inspector {
  min-width: 0;
  padding: var(--space-2);
}

.mapPanel,
.semanticPanel,
.inspector {
  display: grid;
  gap: var(--space-2);
}

.viewActions {
  justify-content: flex-start;
}

.mapHeader,
.semanticHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-2);
}

.mapViewport {
  min-height: 28rem;
  overflow: auto;
  border: 1px solid var(--color-hairline);
  border-radius: var(--radius-control);
  background: var(--color-recessed);
}

.mapCanvas {
  display: block;
  min-width: 42rem;
  width: 100%;
  height: auto;
}

.edge {
  fill: none;
  stroke: var(--color-text-tertiary);
  stroke-width: 2;
  cursor: pointer;
}

.edge[data-selected="true"] {
  stroke: var(--color-accent);
  stroke-width: 3;
}

.edgeLabel {
  fill: var(--color-text-secondary);
  font-size: 12px;
  pointer-events: none;
}

.node {
  color: var(--color-text-primary);
  cursor: pointer;
}

.nodeShape {
  fill: var(--color-surface-raised);
  stroke: var(--color-boundary);
  stroke-width: 2;
}

.node[data-root="true"] .nodeShape {
  fill: var(--color-accent-subtle);
  stroke: var(--color-accent);
}

.node[data-selected="true"] .nodeShape {
  fill: var(--color-accent);
  stroke: var(--color-accent);
}

.nodeLabel,
.nodeType {
  pointer-events: none;
  text-anchor: middle;
}

.nodeLabel {
  fill: var(--color-text-primary);
  font-size: 14px;
  font-weight: 700;
}

.nodeType {
  fill: var(--color-text-secondary);
  font-size: 11px;
}

.node[data-selected="true"] .nodeLabel,
.node[data-selected="true"] .nodeType {
  fill: var(--color-action-inverse-text);
}

.itemGroup {
  display: grid;
  gap: var(--space-1);
}

.itemGroupHeading {
  margin: 0;
  color: var(--color-text-secondary);
  font-size: 0.8125rem;
  font-weight: 750;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.itemList {
  display: grid;
  margin: 0;
  padding: 0;
  list-style: none;
  border-top: 1px solid var(--color-hairline);
}

.itemRow {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  width: 100%;
  gap: var(--space-2);
  min-height: var(--target-min);
  padding: var(--space-1);
  border-bottom: 1px solid var(--color-hairline);
  background: transparent;
  color: var(--color-text-primary);
}

.itemSelect {
  display: grid;
  min-width: 0;
  gap: 2px;
  padding: 0;
  border: 0;
  background: transparent;
  color: inherit;
  text-align: start;
  cursor: pointer;
}

.itemAction {
  min-height: var(--target-min);
  padding-inline: var(--space-1);
  border: 1px solid transparent;
  border-radius: var(--radius-control);
  background: transparent;
  color: var(--color-accent);
  font: inherit;
  font-size: 0.8125rem;
  font-weight: 750;
  cursor: pointer;
}

.itemAction:hover {
  border-color: var(--color-hairline);
  background: var(--color-surface-raised);
}

.itemRow:hover {
  background: var(--color-surface-raised);
}

.itemRow[data-selected="true"] {
  background: var(--color-accent-subtle);
  box-shadow: inset 3px 0 var(--color-accent);
}

.itemCopy {
  display: grid;
  gap: 2px;
  min-width: 0;
}

.itemType {
  color: var(--color-text-tertiary);
}

.inspector {
  position: sticky;
  top: var(--shell-safe-top);
}

.inspectorHeader {
  justify-content: space-between;
}

.inspectorHeader h2 {
  min-width: 0;
  max-width: 18rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.inspectorActions {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-1);
}

.inspectorDetails {
  display: grid;
  gap: var(--space-1);
  margin: 0;
}

.inspectorDetails div {
  display: grid;
  grid-template-columns: 7rem minmax(0, 1fr);
  gap: var(--space-1);
  padding-bottom: var(--space-1);
  border-bottom: 1px solid var(--color-hairline);
}

.inspectorDetails dt {
  color: var(--color-text-secondary);
  font-size: 0.8125rem;
}

.inspectorDetails dd {
  min-width: 0;
  margin: 0;
  overflow-wrap: anywhere;
}

.editorDisclosure {
  padding-top: var(--space-2);
  border-top: 1px solid var(--color-hairline);
}

.editorDisclosure summary {
  min-height: var(--target-min);
  cursor: pointer;
  color: var(--color-text-primary);
  font-weight: 700;
  line-height: var(--target-min);
}

.linkForm {
  display: grid;
  gap: var(--space-1);
  padding-top: var(--space-1);
}

.linkForm label {
  display: grid;
  gap: 2px;
  color: var(--color-text-secondary);
  font-size: 0.8125rem;
}

.linkForm select {
  width: 100%;
}

.dangerButton {
  border-color: var(--color-danger);
  background: var(--color-danger-subtle);
  color: var(--color-danger);
}

.error {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: var(--space-1);
  margin: 0;
  color: var(--color-danger);
  font-weight: 650;
}

.pagination {
  justify-content: space-between;
}

@media (max-width: 960px) {
  .content {
    grid-template-columns: 1fr;
  }

  .inspector {
    position: static;
  }
}

@media (max-width: 700px) {
  .searchLine {
    grid-template-columns: 1fr;
  }

  .searchButton {
    width: 100%;
  }

  .mapViewport {
    min-height: 22rem;
  }

  .mapCanvas {
    min-width: 36rem;
  }

  .rootResult {
    grid-template-columns: minmax(0, 1fr) auto;
  }

  .rootResultType {
    grid-column: 1;
  }

  .rootResult .resultArrow {
    grid-column: 2;
    grid-row: 1 / span 2;
  }

  .inspectorDetails div {
    grid-template-columns: 1fr;
    gap: 2px;
  }
  .onboardingSteps {
    grid-template-columns: 1fr;
  }

  .onboardingLinks {
    display: grid;
  }

  .onboardingLinks > * {
    width: 100%;
  }

  .rootResult .resultAction {
    grid-column: 2;
    grid-row: 1 / span 2;
  }
}
